import { Grid, Paper, Title, UnstyledButton } from "@mantine/core";
import { BusinessTypes } from "../../../enums/business-type";
import "./business-type.styles.css";

function BusinessTypeButton(props: {
  name: string;
  clicked: boolean;
  value: number;
  setClicked: any;
  icon: JSX.Element;
}) {
  const { name, clicked, setClicked, value, icon } = props;

  const handleChange = () => {
    setClicked(value);
  };
  return (
    <div className="business-type-button">
      <UnstyledButton
        style={{ width: "100%" }}
        className={clicked ? "full-opacity clicked" : "half-opacity"}
        onClick={handleChange}
      >
        <Paper p={25} shadow="md">
          <Grid align="center">
            <Grid.Col xs={4}>
              <div className="button-icon">{icon}</div>
            </Grid.Col>
            <Grid.Col xs={8}>
              <Title order={2} style={{ fontWeight: 400 }}>
                {name}
              </Title>
              {value === BusinessTypes.STARTER && (
                <Title order={3} style={{ fontWeight: 300 }}>
                  (Unregistered Business)
                </Title>
              )}
            </Grid.Col>
          </Grid>
        </Paper>
      </UnstyledButton>
    </div>
  );
}

export default BusinessTypeButton;
